import { useTranslation } from '@portals-platform/i18n';
import { useMemo } from 'react';

export function useTranslatedLabels(keys: Record<string, string>): Record<string, string> {
  const { t } = useTranslation();

  return useMemo(
    () => Object.fromEntries(Object.entries(keys).map(([field, key]) => [field, t(key)])),
    [keys, t],
  );
}
